import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { d: "M16.5 16.5L12 12M12 12L7.5 7.5M12 12L7.5 16.5M12 12L16.5 7.5M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
export {
  t as default
};
//# sourceMappingURL=help-close.js.map
